'use strict';

var processInclude = require('./util');

$(document).ready(function () {
	//login moved to main.js script
    //processInclude(require('./login/login'));
});
